// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../fonts/stylesheet.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}
html ::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
html ::-webkit-scrollbar-thumb {
  background: rgb(33, 39, 42);
  border-radius: 10px;
}
html ::-webkit-scrollbar-thumb:hover {
  background: rgb(18, 22, 25);
}
html ::-webkit-scrollbar-track {
  background: 0;
}
html body {
  direction: rtl;
  margin: 0;
  font-family: "Heebo";
  background-color: rgb(192, 211, 218);
}
html body *,
html body *::after,
html body *::before {
  box-sizing: border-box;
}
html body a {
  text-decoration: none;
  color: inherit;
}
html body img {
  max-width: 100%;
  max-height: 100%;
  display: block;
}
html body .relative {
  position: relative;
}
html body .absolute {
  position: absolute;
}
html body .fixed {
  position: fixed;
}
html body .flex {
  display: flex;
}
html body .column {
  flex-direction: column;
}
html body .align-center {
  align-items: center;
}
html body .align-start {
  align-items: flex-start;
}
html body .align-end {
  align-items: flex-end;
}
html body .align-base {
  align-items: baseline;
}
html body .justify-center {
  justify-content: center;
}
html body .justify-start {
  justify-content: flex-start;
}
html body .justify-end {
  justify-content: flex-end;
}
html body .justify-between {
  justify-content: space-between;
}
html body .wrap {
  flex-wrap: wrap;
}
html body .nowrap {
  flex-wrap: nowrap;
}
html body .row {
  flex-direction: row;
}
html body .row-reverse {
  flex-direction: row-reverse;
}
html body .absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
html body .App {
  display: flex;
  column-gap: min(62px, 5vw);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/general.scss"],"names":[],"mappings":"AAEA;EACE,uBAAA;AAAF;AAEE;EACE,UAAA;EACA,WAAA;AAAJ;AAGE;EACE,2BAAA;EACA,mBAAA;AADJ;AAIE;EACE,2BAAA;AAFJ;AAIE;EACE,aAAA;AAFJ;AAKE;EACE,cAAA;EACA,SAAA;EACA,oBAAA;EACA,oCAAA;AAHJ;AAKI;;;EAGE,sBAAA;AAHN;AAMI;EACE,qBAAA;EACA,cAAA;AAJN;AAOI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AALN;AASI;EACE,kBAAA;AAPN;AAUI;EACE,kBAAA;AARN;AAWI;EACE,eAAA;AATN;AAaI;EACE,aAAA;AAXN;AAcI;EACE,sBAAA;AAZN;AAeI;EACE,mBAAA;AAbN;AAgBI;EACE,uBAAA;AAdN;AAiBI;EACE,qBAAA;AAfN;AAkBI;EACE,qBAAA;AAhBN;AAmBI;EACE,uBAAA;AAjBN;AAoBI;EACE,2BAAA;AAlBN;AAqBI;EACE,yBAAA;AAnBN;AAsBI;EACE,8BAAA;AApBN;AAuBI;EACE,eAAA;AArBN;AAwBI;EACE,iBAAA;AAtBN;AAyBI;EACE,mBAAA;AAvBN;AA0BI;EACE,2BAAA;AAxBN;AA0BI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAxBN;AA4BI;EACE,aAAA;EACA,0BAAA;AA1BN","sourcesContent":["@import '../fonts/stylesheet.css';\n\nhtml {\n  scroll-behavior: smooth;\n\n  ::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: rgb(33, 39, 42);\n    border-radius: 10px;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background: rgb(18, 22, 25);\n  }\n  ::-webkit-scrollbar-track {\n    background: 000;\n  }\n\n  body {\n    direction: rtl;\n    margin: 0;\n    font-family: 'Heebo';\n    background-color: rgba(192, 211, 218, 1);\n\n    *,\n    *::after,\n    *::before {\n      box-sizing: border-box;\n    }\n\n    a {\n      text-decoration: none;\n      color: inherit;\n    }\n\n    img {\n      max-width: 100%;\n      max-height: 100%;\n      display: block;\n    }\n\n    //position\n    .relative {\n      position: relative;\n    }\n\n    .absolute {\n      position: absolute;\n    }\n\n    .fixed {\n      position: fixed;\n    }\n\n    //flex\n    .flex {\n      display: flex;\n    }\n\n    .column {\n      flex-direction: column;\n    }\n\n    .align-center {\n      align-items: center;\n    }\n\n    .align-start {\n      align-items: flex-start;\n    }\n\n    .align-end {\n      align-items: flex-end;\n    }\n\n    .align-base {\n      align-items: baseline;\n    }\n\n    .justify-center {\n      justify-content: center;\n    }\n\n    .justify-start {\n      justify-content: flex-start;\n    }\n\n    .justify-end {\n      justify-content: flex-end;\n    }\n\n    .justify-between {\n      justify-content: space-between;\n    }\n\n    .wrap {\n      flex-wrap: wrap;\n    }\n\n    .nowrap {\n      flex-wrap: nowrap;\n    }\n\n    .row {\n      flex-direction: row;\n    }\n\n    .row-reverse {\n      flex-direction: row-reverse;\n    }\n    .absolute-center {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n\n    // make the sidebar and the rest of the page be one near another\n    .App {\n      display: flex;\n      column-gap: min(62px, 5vw);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
